/**
 * A number and the noun it counts, agreeing.
 *
 * "1 things you could do here" was on screen for a long time because every
 * line that counted something wrote its own plural, and every one of them
 * wrote the plural. One function, so a count of one is a count of one
 * everywhere.
 *
 *   count(1, 'round')             -> '1 round'
 *   count(3, 'round')             -> '3 rounds'
 *   count(1, 'person', 'people')  -> '1 person'
 */
export function count(n, one, many = `${one}s`) {
  return `${n} ${n === 1 ? one : many}`;
}

/** Just the noun, for a line that puts the number somewhere else. */
export function noun(n, one, many = `${one}s`) {
  return n === 1 ? one : many;
}

/**
 * A person as a sentence names them: "Roz" as herself, "the Housekeeping
 * Lead" with an article. Some of the roster have names and some are their
 * job, and "talk to Housekeeping Lead" reads like a telegram.
 */
const JOB = /\b(Cuisine|Steward|Lead|Attendant|Captain|Runner|Foreman|on Call|Agent|Auditor|Supervisor|Manager|Porter|Guest)$/;
export function whom(name) {
  if (!name) return 'them';
  return !/["']/.test(name) && JOB.test(name) ? `the ${name}` : name;
}

/** A line's first letter up, for a phrase that starts a sentence. */
export function sentence(text) {
  return text ? text[0].toUpperCase() + text.slice(1) : text;
}

/** "the orange", but "yesterday's shrimp": no article before a possessive. */
export function the(noun) {
  return /^\w+'s\b/.test(noun) ? noun : `the ${noun}`;
}
